import { PreviewDeliveryOption } from '@global/utils/orderUtils';

export interface ShippingInfoFormValuesType {
  firstName: string;
  lastName: string;
  country: string;
  address1: string;
  address2?: string;
  city: string;
  zip: string;
  state: string;
  phone: string;
  uid?: string;
  email?: string;
  wNewAddress?: boolean;
  deliveryOption?: PreviewDeliveryOption;
}

export interface IShippingInfo {
  firstName?: string;
  lastName?: string;
  phone?: string;
  addressOne: string;
  addressTwo?: string;
  city: string;
  state: string;
  zip: string;
  country: {
    name: string;
    numericCode?: string;
    iso2Code?: string;
  };
  uid?: string;
  wNewAddress?: boolean;
  email?: string;
  deliveryInfo?: PreviewDeliveryOption;
}

export const EMPTY_SHIPPING_FORM_VALUES: Omit<
  ShippingInfoFormValuesType,
  'country'
> = {
  city: '',
  state: '',
  zip: '',
  address1: '',
  address2: '',
  phone: '',
  firstName: '',
  lastName: '',
};
